;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="f6e390ac-82b9-4f3a-b335-f867c2cbfb49",e._sentryDebugIdIdentifier="sentry-dbid-f6e390ac-82b9-4f3a-b335-f867c2cbfb49")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default from 'react';
import styles from './Icon.module.scss.js';
import '../../_virtual/_sentry-release-injection-file.js';

/* eslint-disable react/jsx-props-no-spreading */
function ThemedIcon({ Icon, color, className, aligned, ...props }) {
    return (React__default.createElement(Icon, { className: classNames(className, {
            [styles.iconWhite]: color === 'white',
            [styles.iconNeutralDark]: color === 'neutralDark',
            [styles.iconPrimary]: color === 'primary',
            [styles.iconSecondary]: color === 'secondary',
            [styles.iconError]: color === 'error',
            [styles.iconAligned]: aligned,
        }), ...props }));
}

export { ThemedIcon };
//# sourceMappingURL=Icon.js.map
